// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2hAAZ","title":"Images45_title__cbR3D","images":"Images45_images__3VNTS"};